export function startDownload(size, selected) {

    let canvas = document.createElement("canvas");
    let context = canvas.getContext("2d");
    const title = selected.csi_code + " - " + selected.csi_name;
    if (size === "large") {
       canvas.width = 300;
       canvas.height = 400;
      context.fillStyle = "rgb(255,255,255)";
      context.fillRect(0, 0, 300, 400);
      context.fillStyle = selected.hex;
      context.fillRect(0, 0, 300, 350);
      context.font = "bold 24px Helvetica, sans-serif";
      context.fillStyle = "black";
      context.textAlign = "center";
      context.fillText(title.toUpperCase(), 150, 385);
      context.strokeStyle = "#000000";
      context.strokeRect(1, 1, 298, 398);
      // context.moveTo(0, 350);
      // context.lineTo(300, 350);

    }
    if (size === "small") {
      canvas.width = 250;
      canvas.height = 70;

      context.fillStyle = "rgb(255,255,255)";
      context.fillRect(0, 0, 250, 70);
      context.fillStyle = selected.hex;
      context.fillRect(0, 0, 70, 70);
      context.font = "bold 14px Helvetica, sans-serif";
      context.fillStyle = "black";
      context.textAlign = "center";

      context.fillText(title.toUpperCase(), 160, 40);
      context.strokeStyle = "#000000";
      context.strokeRect(1, 1, 248, 68);
      context.stroke();
    }

    try {
      localStorage.setItem(
        "saved-image-example",
        canvas.toDataURL("image/jpg")
      );
      var url = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      //var url = canvas.toDataURL("image/png");
      var link = document.createElement("a");
      link.download = `${selected.csi_code}-${selected.csi_name}.png`;
      link.href = url;
      link.click();
    } catch (err) {
      console.log("Error: " + err);
    }
  }